import React from 'react'
import { renderChildren } from './helpers'

export class EduElse extends React.PureComponent {
  render() {
    return renderChildren(this.props)
  }
}
